module.exports = __webpack_public_path__ + "static/media/cre8.6090d906.png";